"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsteroidHollowingRebalanced = void 0;
var Card_1 = require("../../Card");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var ResourceType_1 = require("../../../ResourceType");
var Tags_1 = require("../../Tags");
var Resources_1 = require("../../../Resources");
var CardRenderer_1 = require("../../render/CardRenderer");
var CardRenderDynamicVictoryPoints_1 = require("../../render/CardRenderDynamicVictoryPoints");
var AsteroidHollowingRebalanced = (function (_super) {
    __extends(AsteroidHollowingRebalanced, _super);
    function AsteroidHollowingRebalanced() {
        var _this = _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.ASTEROID_HOLLOWING_REBALANCED,
            tags: [Tags_1.Tags.SPACE],
            cost: 16,
            resourceType: ResourceType_1.ResourceType.ASTEROID,
            metadata: {
                cardNumber: 'X15',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Spend 1 titanium to add 1 asteroid resource here and increase M€ production 1 step.', function (eb) {
                        eb.titanium(1).startAction.asteroids(1).production(function (pb) { return pb.megacredits(1); });
                    }).br;
                    b.vpText('1VP for each asteroid on this card.');
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.asteroids(1, 1),
            },
        }) || this;
        _this.resourceCount = 0;
        return _this;
    }
    AsteroidHollowingRebalanced.prototype.play = function () {
        return undefined;
    };
    AsteroidHollowingRebalanced.prototype.canAct = function (player) {
        return player.titanium > 0;
    };
    AsteroidHollowingRebalanced.prototype.action = function (player) {
        player.deductResource(Resources_1.Resources.TITANIUM, 1);
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1);
        player.addResourceTo(this, { log: true });
        return undefined;
    };
    AsteroidHollowingRebalanced.prototype.getVictoryPoints = function () {
        return Math.floor(this.resourceCount / 1);
    };
    return AsteroidHollowingRebalanced;
}(Card_1.Card));
exports.AsteroidHollowingRebalanced = AsteroidHollowingRebalanced;
//# sourceMappingURL=AsteroidHollowingRebalanced.js.map